import {css} from 'styled-components';
export const CardColors = css`
    // === part of V1 Card compoenent === //
    --card-body-background-color-100: var(--container-background-color-100);
    --card-text-color-100: var(--default-text-color);
    --card-shadow-color-100: var(--container-shadow-color-100);

    --card-body-background-color-200: var(--container-background-color-200);
    --card-shadow-color-200: var(--container-shadow-color-200);
`;
